export { default } from './PopupActions';
//# sourceMappingURL=index.js.map